import { render, staticRenderFns } from "./wizard-store-close.vue?vue&type=template&id=d1d95df6"
import script from "./wizard-store-close.vue?vue&type=script&lang=ts"
export * from "./wizard-store-close.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports